"use strict";

import axios from "./axiosWrapper";
import * as PasswordValidator from 'password-validator';

const validatePassword = (password) => {
    return new Promise(((resolve, reject) => {
        const schema = new PasswordValidator();
        schema.is().min(8)
            .is().max(100)
            .has().uppercase()
            .has().lowercase()
            .has().digits(1)
            .has().symbols(1);
        const results = schema.validate(password, { list: true });
        if(!results.length){
            axios.get('validates/passwords', {
                params: {
                    password: password,
                }
            }).then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error?.data?.errors?.password);
            });
        }
        else{
            const messages = {
                digits: 'a number is required',
                letters: 'letters are required',
                lowercase: 'a lowercase character is required',
                uppercase: 'an uppercase character is required',
                symbols: 'a symbol is required',
                min: 'minimum length is 8',
                max: 'maximum length is 100',
            };
            const resultsWithMessages = results.map((result)=>{return messages[result] || null;}).filter(x => x);
            reject(resultsWithMessages);
        }
    }));
};

export default validatePassword;
